import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adloop-card',
  templateUrl: './adloop-card.component.html',
  styleUrls: ['./adloop-card.component.scss']
})
export class AdloopCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
